/**
 * demo示例 开发时请删除以下demo
 * */
import api from '../api';

export const showModal = ({ commit }, { modaldata, type }) => {
  commit('showModal', { modaldata, type });
  commit('toggleModal');
};

export const setScreen9Data = ({ commit }) => {
  api.screen9
    .getData()
    .then(res => {
      if (res.success || res.code === '000') {
        commit('setScreen9', res.data);
      }
    }).catch(e => {
      console.log(e, '模拟数据服务未运行 请执行npm run mock');
    });
};
